import { axios } from "../../../lib"

export const updateRule = async ({
    id=null,
    cif=null,
    partnerCIF=null,
    pointOfWork=null,
    category
}) => {
    return axios.put("/nomenclatures/rules",{
        id,
        cif,
        partnerCIF,
        pointOfWork,
        category
    })
}